// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';

// export default function ProfilePhoto() {
//   const [dragActive, setDragActive] = useState(false);
//   // const [key, setKey] = useState('upload');
//   const [selectedPhoto, setSelectedPhoto] = useState(null);
//   const [savedPhoto, setSavedPhoto] = useState(null);
//   const [cameraActive, setCameraActive] = useState(false);
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     axios
//       .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         setSavedPhoto(response.data.profile_pic || 'placeholder.png');
//       })
//       .catch((error) => {
//         console.error('Error fetching profile photo:', error);
//       });
//   }, [token]);

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragActive(false);
//     if (e.dataTransfer.files && e.dataTransfer.files[0]) {
//       handleFileUpload(e.dataTransfer.files[0]);
//     }
//   };

//   const handleChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       handleFileUpload(e.target.files[0]);
//     }
//   };

//   const handleFileUpload = (file) => {
//     if (!file.type.startsWith("image/")) {
//       Swal.fire("Invalid File", "Please upload a valid image file.", "error");
//       return;
//     }
//     const reader = new FileReader();
//     reader.onload = () => {
//       setSelectedPhoto(reader.result);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleSave = () => {
//     axios
//       .patch(
//         'https://kaasbackend.vetrinahealthcare.com/lms/user/',
//         { profile_pic: selectedPhoto },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         setSavedPhoto(selectedPhoto);
//         setSelectedPhoto(null);
//         Swal.fire({
//           title: "Success!",
//           text: "Profile photo updated successfully.",
//           icon: "success",
//           confirmButtonText: "OK",
//         });
//       })
//       .catch((error) => {
//         console.error('Error saving profile photo:', error);
//         Swal.fire("Error", "Failed to save profile photo.", "error");
//       });
//   };

//   const handleClear = () => {
//     setSelectedPhoto(null);
//   };

//   const handleStartCamera = () => {
//     setCameraActive(true);
//     navigator.mediaDevices
//       .getUserMedia({ video: true })
//       .then((stream) => {
//         videoRef.current.srcObject = stream;
//         videoRef.current.play();
//       })
//       .catch((err) => {
//         console.error("Error accessing camera:", err);
//         Swal.fire("Error", "Failed to access camera.", "error");
//       });
//   };

//   const handleCapturePhoto = () => {
//     const canvas = canvasRef.current;
//     const video = videoRef.current;
//     const context = canvas.getContext("2d");

//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;

//     context.drawImage(video, 0, 0, canvas.width, canvas.height);
//     const dataURL = canvas.toDataURL("image/png");
//     setSelectedPhoto(dataURL);

//     stopCamera();
//   };

//   const stopCamera = () => {
//     const stream = videoRef.current.srcObject;
//     const tracks = stream.getTracks();
//     tracks.forEach((track) => track.stop());
//     setCameraActive(false);
//   };

//   return (
//     <div style={{ width: '100%', maxWidth: '768px', margin: '20px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
//       <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//         <h2>Change Profile Photo</h2>
//       </div>

//       <div style={{ marginBottom: '20px', textAlign: 'center' }}>
//         <p style={{ fontSize: '1.2rem', marginBottom: '10px' }}>Current Profile Photo</p>
//         <img
//           src={savedPhoto}
//           alt="Current Profile"
//           style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover', marginBottom: '10px' }}
//         />
//       </div>

//       <div style={{ marginBottom: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', backgroundColor: dragActive ? '#e0f7fa' : '#f9f9f9' }}
//         onDragEnter={() => setDragActive(true)}
//         onDragLeave={() => setDragActive(false)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={handleDrop}
//       >
//         <p style={{ fontWeight: 'bold', color: '#333' }}>Drop your image here or{' '}
//           <label style={{ color: '#007bff', cursor: 'pointer' }}>
//             select a file
//             <input
//               type="file"
//               style={{ display: 'none' }}
//               accept="image/*"
//               onChange={handleChange}
//             />
//           </label>
//         </p>
//       </div>

//       <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//         <button style={{ padding: '10px 20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={handleStartCamera}>
//           Take Live Photo
//         </button>
//       </div>

//       {cameraActive && (
//         <div style={{ textAlign: 'center', marginBottom: '20px' }}>
//           <video ref={videoRef} style={{ borderRadius: '10px', marginBottom: '10px', width: '100%' }} />
//           <div>
//             <button style={{ padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', marginRight: '10px' }} onClick={handleCapturePhoto}>
//               Capture Photo
//             </button>
//             <button style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={stopCamera}>
//               Cancel
//             </button>
//           </div>
//           <canvas ref={canvasRef} style={{ display: 'none' }} />
//         </div>
//       )}

//       {selectedPhoto && (
//         <div style={{ textAlign: 'center', marginTop: '20px' }}>
//           <p style={{ fontSize: '1.2rem' }}>Preview</p>
//           <img
//             src={selectedPhoto}
//             alt="Profile Preview"
//             style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover', marginBottom: '10px' }}
//           />
//           <div>
//             <button style={{ marginRight: '10px', padding: '10px 20px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={handleSave}>
//               Save Photo
//             </button>
//             <button style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={handleClear}>
//               Clear
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

export default function ProfilePhoto() {
  const [dragActive, setDragActive] = useState(false)
  // const [key, setKey] = useState('upload');
  const [selectedPhoto, setSelectedPhoto] = useState(null)
  const [savedPhoto, setSavedPhoto] = useState(null)
  const [cameraActive, setCameraActive] = useState(false)
  const videoRef = useRef(null)
  const canvasRef = useRef(null)
  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    axios
      .get('https://kaasbackend.vetrinahealthcare.com/lms/user/', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSavedPhoto(response.data.profile_pic || 'placeholder.png')
      })
      .catch((error) => {
        console.error('Error fetching profile photo:', error)
      })
  }, [token])

  const handleDrop = (e) => {
    e.preventDefault()
    setDragActive(false)
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0])
    }
  }

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFileUpload(e.target.files[0])
    }
  }

  const handleFileUpload = (file) => {
    if (!file.type.startsWith('image/')) {
      Swal.fire('Invalid File', 'Please upload a valid image file.', 'error')
      return
    }
    const reader = new FileReader()
    reader.onload = () => {
      setSelectedPhoto(reader.result)
    }
    reader.readAsDataURL(file)
  }

  const handleSave = () => {
    axios
      .patch(
        'https://kaasbackend.vetrinahealthcare.com/lms/user/',
        { profile_pic: selectedPhoto },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setSavedPhoto(selectedPhoto)
        setSelectedPhoto(null)
        Swal.fire({
          title: 'Success!',
          text: 'Profile photo updated successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        })
      })
      .catch((error) => {
        console.error('Error saving profile photo:', error)
        Swal.fire('Error', 'Failed to save profile photo.', 'error')
      })
  }

  const handleClear = () => {
    setSelectedPhoto(null)
  }

  const handleStartCamera = () => {
    setCameraActive(true)
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        videoRef.current.srcObject = stream
        videoRef.current.play()
      })
      .catch((err) => {
        console.error('Error accessing camera:', err)
        Swal.fire('Error', 'Failed to access camera.', 'error')
      })
  }

  const handleCapturePhoto = () => {
    const canvas = canvasRef.current
    const video = videoRef.current
    const context = canvas.getContext('2d')

    canvas.width = video.videoWidth
    canvas.height = video.videoHeight

    context.drawImage(video, 0, 0, canvas.width, canvas.height)
    const dataURL = canvas.toDataURL('image/png')
    setSelectedPhoto(dataURL)

    stopCamera()
  }

  const stopCamera = () => {
    const stream = videoRef.current.srcObject
    const tracks = stream.getTracks()
    tracks.forEach((track) => track.stop())
    setCameraActive(false)
  }

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '768px',
        margin: '20px auto',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2>Change Profile Photo</h2>
      </div>

      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
          Current Profile Photo
        </p>
        <img
          src={savedPhoto}
          alt='Current Profile'
          style={{
            borderRadius: '50%',
            width: '100px',
            height: '100px',
            objectFit: 'cover',
            marginBottom: '10px',
          }}
        />
      </div>

      <div
        style={{
          marginBottom: '20px',
          border: '2px dashed #ccc',
          padding: '20px',
          borderRadius: '10px',
          backgroundColor: dragActive ? '#e0f7fa' : '#f9f9f9',
        }}
        onDragEnter={() => setDragActive(true)}
        onDragLeave={() => setDragActive(false)}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <p style={{ fontWeight: 'bold', color: '#333' }}>
          Drop your image here or{' '}
          <label style={{ color: '#007bff', cursor: 'pointer' }}>
            select a file
            <input
              type='file'
              style={{ display: 'none' }}
              accept='image/*'
              onChange={handleChange}
            />
          </label>
        </p>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <button
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          onClick={handleStartCamera}
        >
          Take Live Photo
        </button>
      </div>

      {cameraActive && (
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <video
            ref={videoRef}
            style={{
              borderRadius: '10px',
              marginBottom: '10px',
              width: '100%',
            }}
          />
          <div>
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: '#28a745',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
              onClick={handleCapturePhoto}
            >
              Capture Photo
            </button>
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onClick={stopCamera}
            >
              Cancel
            </button>
          </div>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
        </div>
      )}

      {selectedPhoto && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ fontSize: '1.2rem' }}>Preview</p>
          <img
            src={selectedPhoto}
            alt='Profile Preview'
            style={{
              borderRadius: '50%',
              width: '100px',
              height: '100px',
              objectFit: 'cover',
              marginBottom: '10px',
            }}
          />
          <div>
            <button
              style={{
                marginRight: '10px',
                padding: '10px 20px',
                backgroundColor: '#28a745',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onClick={handleSave}
            >
              Save Photo
            </button>
            <button
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
